import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ElearnioLoaderComponent } from './elearnio-loader.component';

@NgModule({
  declarations: [ElearnioLoaderComponent],
  imports: [CommonModule],
  exports: [ElearnioLoaderComponent],
})
export class ElearnioLoaderModule {}
